import { render } from "./Wikis.vue?vue&type=template&id=51dc7547"
import script from "./Wikis.vue?vue&type=script&lang=js"
export * from "./Wikis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__